export default __webpack_public_path__ + "static/35-99983c3e322902fee836032fe925c8a2.jpg";